<template>
    <b-container class="my-2">
        <b-row>
            <b-col>
                <b-row>
                    <b-col cols="3">
                        <b-img :src="profilePic"
                            height="60" 
                        />
                    </b-col>
                    <b-col>
                        <b-row>
                            <strong>{{shortenedName}}</strong>
                        </b-row>
                        <b-row>
                            {{city}}
                        </b-row>
                        <b-row>
                            <b-icon icon="person" class="mr-1"></b-icon>{{user_numFriends}}
                            <b-icon icon="asterisk" class="mr-1 ml-3"></b-icon>{{user_numReviews}}
                            <b-icon icon="image" class="mr-1 ml-3"></b-icon>{{user_numPhotos}}
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-icon class="float-right" icon="three-dots"></b-icon>
            </b-col>
        </b-row>
        <b-row class="my-3">
            <b-col>
                <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                {{dateOfReview}}
            </b-col>
        </b-row>
        <b-row class="my-3">
            <b-col>
                <b-icon icon="image" class="mr-2"></b-icon>{{numPhotos}} photos
            </b-col>
        </b-row>
        <b-row class="my-3">
            <b-col>
                <span>
                    {{text}}
                </span>
            </b-col>
        </b-row>
        <b-row class="my-3">
            <b-col cols="3" v-for="photo in photos.slice(0,4)" :key="photo.id">
                <b-img :src="photo.link"
                     height="180"
                     width="180"
                />
            </b-col>
        </b-row>
        <b-row class="my-3">
            <b-col>
                <b-button variant="outline-primary" class="mr-3">
                    <b-icon icon="exclamation-circle" aria-hidden="true"></b-icon>
                    Useful <strong v-if="numReactionUseful > 0">{{numReactionUseful}}</strong>
                
                </b-button>
                <b-button variant="outline-primary" class="mr-3">
                    <b-icon icon="emoji-laughing" aria-hidden="true"></b-icon>
                    Funny <strong v-if="numReactionFunny > 0">{{numReactionFunny}}</strong>
                
                </b-button>
                <b-button variant="outline-primary" class="mr-3">
                    <b-icon icon="emoji-sunglasses" aria-hidden="true"></b-icon>
                    Cool <strong v-if="numReactionCool > 0">{{numReactionCool}}</strong>
                
                </b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
export default {
    components: {

    },
    props: {
        shortenedName: {
            type: String
        },
        profilePic: {
            type: String
        },
        user_numFriends: {
            type: Number
        },
        user_numReviews: {
            type: Number
        },
        user_numPhotos: {
            type: Number
        },
        city: {
            type: String
        },
        dateOfReview: {
            type: String
        },
        numPhotos: {
            type: Number
        },
        text: {
            type: String
        },
        numReactionUseful: {
            type: Number
        },
        numReactionFunny: {
            type: Number
        },
        numReactionCool: {
            type: Number
        },
        photos: {
            type: Array
        }
    },
    data() {
        return {

        }
    },
    computed: {

    }
}
</script>